import CourseUnit from './CourseUnit';

export default CourseUnit;
